import React, {Component} from 'react';
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import {isValidMailProperty} from "../../../common/componentValidation";
import SweetAlert from "react-bootstrap-sweetalert";

class MailProperty extends Component {

    constructor(props) {
        super(props);
        this.state = {
            protocol: "smtp",
            host: "",
            port: 587,
            user: "",
            password: "",
            encryption: "",
            signatureText: "",
            signatureLogoPath: "",
            alert: null,
            disabled: false,
            mailProperty: null,
            selectedFilePath: "",
            fileImage: null,
            fileUrl: "",
            image: null
        };


        this.saveMailProperty = this.saveMailProperty.bind(this);
        this.deleteMailProperty = this.deleteMailProperty.bind(this);
        this.getCustomerProperties = this.getCustomerProperties.bind(this);
    }

    componentDidMount() {
        this.getCustomerProperties();
    }

    getCustomerProperties() {
        let self = this;
        let params = {
            url: `/mail/getCustomerProperties`,
            method: "post",
            data: {
                customerId: self.props.customer.recordId
            }
        };
        request(params)
            .then(function (response) {
                let mailProperty = response.data;
                if (mailProperty && mailProperty.recordId) {
                    self.setState({
                        mailProperty: mailProperty,
                        recordId: mailProperty.recordId,
                        customerId: self.props.customer.recordId,
                        vknTckn: self.props.customer.vknTckn,
                        protocol: mailProperty.protocol,
                        host: mailProperty.host,
                        port: mailProperty.port,
                        user: mailProperty.user,
                        password: mailProperty.password,
                        encryption: mailProperty.encryption,
                        signatureText: mailProperty.signatureText,
                        signatureLogoPath: mailProperty.signatureLogoPath,
                        createdAt: mailProperty.createdAt,
                        createdBy: mailProperty.createdBy,
                        disabled: false,
                    });
                    self.setImage(mailProperty.signatureLogoPath)
                    /*'data:image/svg+xml;base64,'*/
                } else {
                    self.setState({
                        mailProperty: null,
                        protocol: "smtp",
                        port: 587,
                        host: "",
                        user: "",
                        password: "",
                        encryption: "",
                        signatureText: "",
                        disabled: true,
                        recordId: null,
                        createdBy: null,
                        updatedBy: null,
                        deletedBy: null,
                    });
                }
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    async setImage(path) {
        let imgparam = {
            url: `/mail/showMailImage`,
            method: "post",
            data: path
        }

        let data = "";
        await request(imgparam).then(response => {
            console.log(response);
            data = response.data;
            /*let binaryData = [];
            binaryData.push(response.data);
            resdata = new Blob(binaryData,{type:"image/png"});*/
            //resdata = window.URL.createObjectURL(new Blob(binaryData,{type:"data:image/png"}));


            //resdata = "data:image/png;base64," + btoa(unescape(encodeURIComponent(response.data)));
            //resdata = "data:image/png;base64," + (response.data);

        });

        let tag = document.getElementById("logo")


        tag.src = "data:image/png;base64," + data;
    }

    async uploadMailImage(file) {
        const imageData = new FormData();
        let responseResult = ""
        imageData.append("file", file);
        let params = {
            url: `/mail/uploadMailImage`,
            method: "post",
            data: imageData,
        };
        await request(params)
            .then(response => {
                if (response.data.state === 'true') {
                    responseResult = response.data.result;
                    this.setState({signatureLogoPath: response.data.result});
                } else {
                    Alert.error(response.data.result, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 7000
                    });
                }
            })
    }

    async saveMailProperty() {
        if (this.state.fileUrl) {
            await this.uploadMailImage(this.state.fileImage);
        }
        let self = this;
        let formData = {
            recordId: self.state.recordId,
            customerId: self.state.customerId,
            vknTckn: self.state.vknTckn,
            protocol: self.state.protocol,
            host: self.state.host,
            port: self.state.port,
            user: self.state.user,
            password: self.state.password,
            encryption: (self.state.encryption === "" ? null : self.state.encryption),
            signatureText: self.state.signatureText,
            signatureLogoPath: self.state.signatureLogoPath,
            createdAt: self.state.createdAt,
            createdBy: self.state.createdBy,
        };

        let result = isValidMailProperty(formData);
        let valid = result.valid;


        if (valid) {
            let params = {
                url: `/mail/saveMailProperty`,
                method: "post",
                data: formData,
            };
            request(params)
                .then(function (response) {
                    Alert.success("E-Posta Sunucu Bilgisi başarılı şekilde kaydedildi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000
                    });
                    self.getCustomerProperties();
                }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }
    }

    deleteMailProperty() {
        let self = this;
        let params = {
            url: `/mail/delete/${self.state.recordId}`,
            method: "post",
        };
        request(params)
            .then(function (response) {
                self.setState({
                    alert: null,
                });
                self.getCustomerProperties();
                Alert.success("E-Posta Sunucu Bilgisi silme işlemi başarılı şekilde gerçekleşti.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
            }).catch(function (error) {
            Alert.error("Silme işlemi gerçekleşmedi!!!", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
            showAxiosError(error);
            self.setState({alert: null});
        });
    }

    onFileChange = (event) => {
        const file = event.target.files[0];
        let reader = new FileReader();
        let url = reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                fileImage: file,
                fileUrl: reader.result
            });
        }
    }

    deleteFile = () => {
        this.setState({
            fileImage: null,
            fileUrl: null,
            signatureLogoPath: null
        })
    }

    render() {
        return (
            <Row className="FormRenk"
                 style={{marginLeft: '0px', paddingLeft: '0px', marginRight: "0px", paddingTop: '30px'}}>
                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>Protocol: *</Label>
                        <Col sm={8}>
                            <Input type="text" value={this.state.protocol}
                                   onChange={(e) => this.setState({protocol: e.target.value})}/>
                        </Col>
                    </FormGroup>
                </Col>
                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>Host: *</Label>
                        <Col sm={8}>
                            <Input type="text" value={this.state.host}
                                   onChange={(e) => this.setState({host: e.target.value})}/>
                        </Col>
                    </FormGroup>
                </Col>
                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>Port: *</Label>
                        <Col sm={8}>
                            <Input type="text" value={this.state.port}
                                   onChange={(e) => this.setState({port: e.target.value})}/>
                        </Col>
                    </FormGroup>
                </Col>
                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>E-Posta/Kullanıcı Adı:*</Label>
                        <Col sm={8}>
                            <Input type="text" value={this.state.user}
                                   onChange={(e) => {e.target.value = e.target.value.replaceAll(/[ÜĞŞİÇÖğıüşöç]/g, "");
                                       this.setState({user: e.target.value});
                                   }}
                                   onKeyDown={(e)=>{
                                       if (e.keyCode == 32) {
                                           e.preventDefault();
                                       }
                                   }}
                            />
                        </Col>
                    </FormGroup>
                </Col>
                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>Şifre: *</Label>
                        <Col sm={8}>
                            <Input type="password" value={this.state.password}
                                   onChange={(e) => this.setState({password: e.target.value})}/>
                        </Col>
                    </FormGroup>
                </Col>
                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>Şifreleme Türü: </Label>
                        <Col sm={8}>
                            <Input type="text" value={this.state.encryption}
                                   onChange={(e) => this.setState({encryption: e.target.value})}/>
                        </Col>
                    </FormGroup>
                </Col>
                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>İmza Metni:</Label>
                        <Col sm={8}>
                            <Input type="text" value={this.state.signatureText}
                                   onChange={(e) => this.setState({signatureText: e.target.value})}/>
                        </Col>
                    </FormGroup>
                </Col>
                <Col sm="6">
                    <FormGroup row>
                        <Label sm={4}>Logo:</Label>

                        {this.state.fileUrl || this.state.signatureLogoPath ?
                            <Col sm={8} className="text-center" style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                                <div className="border   rounded border-primary" style={{
                                    minHeight: "150px",
                                    minWidth: "150px",
                                    maxWidth: "150px",
                                    maxHeight: "150px"
                                }}>
                                    {this.state.signatureLogoPath ?
                                        <img id="logo" className=" rounded mx-auto d-block  p-3"/>
                                        :
                                        <img className=" rounded mx-auto d-block  p-3" src={this.state.fileUrl}/>
                                    }
                                </div>

                                <Button onClick={() => this.deleteFile()}
                                        className="text-white bg-danger rounded-circle" size="sm">
                                    Kaldır
                                </Button>


                            </Col>

                            :

                            <Col sm={3}>
                                <Button className="text-white bg-warning" size="sm">
                                    <i className="fas fa-plus" style={{fontSize: "x-large"}}/>
                                    <Input type="file" name="file" onChange={this.onFileChange}/>
                                </Button>

                            </Col>


                        }
                    </FormGroup>
                </Col>

                <Col sm="6">
                    <FormGroup row className="col-sm-12">
                        {/*<Button color="secondary" size="sm" style={{marginTop:"0px"}}>
							Bağlantıyı Test Et
						</Button>*/}
                        <Button className="TekBtn kaydet pull-right"
                                style={{marginRight: "10%"}}
                                onClick={() => this.saveMailProperty()}>
                            Kaydet
                        </Button>
                        <Button className="TekBtn delete bHizala"
                                disabled={this.state.mailProperty === null ? true : false}
                                onClick={e => {
                                    console.log("alert");
                                    this.setState({
                                        alert: (
                                            <SweetAlert showCancel warning
                                                        confirmBtnText="Evet"
                                                        cancelBtnText="Hayır"
                                                        confirmBtnBsStyle="danger"
                                                        cancelBtnBsStyle="default"
                                                        title="Emin misiniz?"
                                                        onConfirm={() => {
                                                            this.deleteMailProperty()
                                                        }}
                                                        onCancel={() => this.setState({alert: null})}>
                                                SMTP bilgileri silinecek devam edilsin mi?
                                            </SweetAlert>)
                                    })
                                }}>
                            Sil
                        </Button>
                    </FormGroup>
                </Col>

                {this.state.alert &&
                <div className="row satirBasi">
                    {this.state.alert}
                </div>
                }
            </Row>
        );
    }
}

export default MailProperty;